import { LINKS } from '@silo/types';
import { ArbitrumIcon, PlainLink } from '@silo/ui';

export function ArbitrumMigrationBanner(): JSX.Element {
  return (
    <div className="flex">
      <div className="p-2.5 rounded-lg bg-blue-300/10 flex items-center gap-2.5">
        <ArbitrumIcon className="w-6 h-6 shrink-0" />

        <p className="font-medium font-sm">
          Silo v2 is now{' '}
          <PlainLink external className="underline" href={LINKS.V2}>
            live on Arbitrum!
          </PlainLink>{' '}
          Migrate your positions today to earn attractive incentives.
        </p>
      </div>
    </div>
  );
}
